//--------------------------------------------
//
// Main
//
//--------------------------------------------
'use strict';


import THREE from 'three';
import Hammer from 'hammerjs';


import Particles from './Particles';
import SKYBOX_IMAGES from './Skyboxes';
import CONSTANTS from './constants';
import Video from './Video';
import Oculus from './Oculus';
import OculusParticles from './OculusParticles';



//--------------------------------------------
//
// Scene
//
//--------------------------------------------
		
class Scene {

	constructor(){
		//DOM container
		this.container = document.getElementById('header');

		
		//Main THREE renderer
		this.renderer = null;

		//Post processing
		this.composer = null;

		//2 Scenes
		this.scene = null;
		this.sceneCube = null;
		
		//2 Cameras
		this.camera = null;
		this.cameraCube = null;
		
		//Sizing + Mouse pos
		this.w = window.innerWidth;
		this.h = window.innerHeight;
		this.windowHalfX = this.w / 2;
		this.windowHalfY = this.h / 2;
		this.targetRotationY = 0;
		this.targetRotationX = 0;
		this.mouseX = 0;
		this.mouseY = 0;

		//last rotateY position
		this.lastRotateY = 0;
		this.lastRotateX = 0;

		//last alpha
		this.lastAlpha = 0;
		
		//Notification Collection
		this.notifications = [];

		//Notification interval
		this.interval = null;
		
		//audio
		this.howl = null;

		//current texture
		this.currentSkybox = 0;

		//video el used for webcam
		this.video = document.getElementById('video');
		this.cam = document.getElementById('cam');
		this.videoOn = false;


		//autorotation of skybox. disable after first pan
		this.autoRotate = true;

		this.device = document.getElementById('device');


		//start
		this.init()
	}

	//--------------------------------------------
	// Init stuff
	//
	init(){
		this.addScene();
		this.addCameras();
		this.addLights();
		this.addSkybox();
		this.addOculus();
		this.addListeners();
		this.animate();



		
	}

	//--------------------------------------------
	//
	// Objects to Add
	//
	//--------------------------------------------
			
	//--------------------------------------------
	// Main scene setup
	//
	addScene(){

		const self = this;
		
		//skybox scene
		this.sceneCube = new THREE.Scene();

		//wall scenes
		this.sceneWall = new THREE.Scene();
		
		this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
		
		this.renderer.setSize(window.innerWidth, window.innerHeight * CONSTANTS.HEIGHT_RATIO);
		this.container.style.height = window.innerHeight * CONSTANTS.HEIGHT_RATIO + 'px';

		this.renderer.setPixelRatio(1);
		
		this.renderer.autoClear = false;
		
		this.container.appendChild(this.renderer.domElement);

		

	}
			

	//--------------------------------------------
	// Camera setup
	//	
	addCameras(){
		
		//Skybox camera
		this.cameraCube = new THREE.PerspectiveCamera(45, this.w / this.h, 1, 100000);
		this.cameraCube.position.z = 5;

		//wall camera
		this.cameraWall = new THREE.PerspectiveCamera(45, this.w / this.h, 1, 10000);
	}




	//--------------------------------------------
	// Add lights (for mesh phong)
	//		
	addLights(){


		// const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
		// directionalLight.position.set( 0, 1, 0 );
		// this.sceneCube.add( directionalLight );

		const ambientLight2 = new THREE.AmbientLight( 0xffffff );
		this.sceneCube.add(ambientLight2);

		const directionalLight2 = new THREE.PointLight( 0xffffff, 1 );
		directionalLight2.position.set( 0, 0, 0 );
		this.sceneWall.add( directionalLight2 );

	}

	//--------------------------------------------
	// Load oculus async
	//
	addOculus(){
		const self = this;

		const gear = new Oculus().then((g) => {
			self.oc = g;
			self.sceneWall.add(self.oc);
		});
	}


	//--------------------------------------------
	// Sparks
	//
	addSparks(){
		const self = this;

		setTimeout(() => {
			const o = OculusParticles(this.sceneWall);

			self.addSparks();
		
		}, this.randomInterval(
			CONSTANTS.SPARKS_RATE[0],
			CONSTANTS.SPARKS_RATE[1]
		));
		
	}
			

	

	//--------------------------------------------
	// Setup skybox
	//
			
	addSkybox(){
		const self = this;
		const skyGeometry = new THREE.CubeGeometry(32,32,32);
		const materialArray = [];


		for (let i = 0; i < 6; i++ ){

			const material = new THREE.MeshPhongMaterial({
				//color: 0x000000,
				map: new THREE.TextureLoader().load(SKYBOX_IMAGES[self.currentSkybox][i]),
				
				side: THREE.BackSide

			});

			materialArray.push(material);
		}

		this.skyMaterial = new THREE.MeshFaceMaterial(materialArray);
		this.skyBox = new THREE.Mesh(skyGeometry, this.skyMaterial);
		this.skyBox.position.z = 0;

		this.sceneCube.add(this.skyBox);
		this.videoOn = false;
	}


	updateVidBox(){
		const self = this;
		console.log('BOX hit');

		const videoTexture = new THREE.VideoTexture(this.video);
		videoTexture.minFilter = THREE.LinearFilter;
		videoTexture.magFilter = THREE.LinearFilter;
		videoTexture.format = THREE.RGBFormat;

		let materialArray = [];


		for (let i = 0; i < 6; i++ ){
			
			let material = new THREE.MeshBasicMaterial({
				map: videoTexture,
				side: THREE.BackSide
			});


			materialArray.push(material);
		}


		
		this.skyMaterial = new THREE.MeshFaceMaterial(materialArray);
		this.skyBox.material = this.skyMaterial;
		this.skyBox.material.needsUpdate = true;

		this.videoOn = true;



	}


	updateSkybox(){
		const self = this;

		this.currentSkybox += 1;

		let videoTexture = null;

		//--------------------------------------------
		// IF NO VIDEO ALLOWED, MAKE SURE TO BACKUP
		//
				

		if (this.currentSkybox > SKYBOX_IMAGES.length - 1){
			this.currentSkybox = 0;
		}



		const materialArray = [];


		for (let i = 0; i < 6; i++ ){

			let material;

			//--------------------------------------------
			// Make backup for when there is no video
			//
			

			material = new THREE.MeshBasicMaterial({
				map: new THREE.TextureLoader().load(SKYBOX_IMAGES[self.currentSkybox][i]),
				side: THREE.BackSide
			});

			materialArray.push(material);
		}

		this.skyMaterial = new THREE.MeshFaceMaterial(materialArray);

		this.skyBox.material = this.skyMaterial;
		this.skyBox.material.needsUpdate = true;
		this.videoOn = false;
	}






	//--------------------------------------------
	// Add reactions
	//	
	addSprites(emoji){
		const p = new Particles(emoji, this.sceneWall);
	}


	//--------------------------------------------
	// Listeners
	//
	addListeners(){
		const self = this;
		this.container.addEventListener('dblclick', this.onLocationClick.bind(this), false);
		this.cam.addEventListener('click', this.onCamClick.bind(this), false);

		const hammertime = new Hammer(this.container);

		hammertime.on('panmove', (ev) => {
			self.rotateSkybox(ev);
		});

		//resize
		window.addEventListener('resize', this.onResize.bind(this), false);

		
	}


	//--------------------------------------------
	// Skybox rotation
	//
	rotateSkybox(ev){

		//disable autoration on first pan
		if (this.autoRotate){
			this.autoRotate = false;
		}

		let distance = ev.distance;


		//left
		if (ev.direction === 2){
			this.skyBox.rotation.y = this.lastRotateY - distance / 3000;
		}
		//right
		else if (ev.direction === 4){
			this.skyBox.rotation.y = this.lastRotateY + distance / 3000;
		}

		//up
		else if (ev.direction === 8){
			this.skyBox.rotation.x = this.lastRotateX + distance / 30000;
		}

		else if (ev.direction === 16){
			this.skyBox.rotation.x = this.lastRotateX - distance / 30000;
		}
		
		this.lastRotateY = this.skyBox.rotation.y;
		this.lastRotateX = this.skyBox.rotation.x;
	}

			


	//--------------------------------------------
	//
	// Event Handlers
	//
	//--------------------------------------------

	onDeviceOrientation(ev){

		//cancel autorotation
		if (this.autoRotate){
			this.autoRotate = false;
		}

		
		
		const alpha = Math.floor(ev.alpha);

	
		this.skyBox.rotation.y = -(alpha / 30) + this.lastAlpha;

		this.lastAlpha = this.skyBox.rotation.x;

		this.device.innerHTML = this.lastAlpha;


	}

	onLocationClick(){
		this.updateSkybox();
	}


	onCamClick(ev){
		const self = this;
		ev.preventDefault();

		if (this.videoEl){

			if (this.videoOn){
				this.updateSkybox();
			}

			else{
				this.updateVidBox();
			}
			
		}

		else{
			this.videoEl = new Video().then((response) => {
				console.log('R', response);
				self.updateVidBox();
				return true;
			}, (err) => {
				
				self.cam.removeEventListener('click', self.onCamClick, false);
				self.cam.remove();

				return false;
			});
			
			
		}
		

	}

	onMouse(ev){
		this.mouseX = ev.clientX - window.innerWidth / 2;
		this.mouseY = ev.clientY - window.innerHeight / 2;


		this.halfMouseX = (ev.clientX / 2) - window.innerWidth;
		this.targetHalfRotationX = this.halfMouseX * 0.001;

		this.targetRotationY = this.mouseY * 0.001;
		this.targetRotationX = this.mouseX * 0.001;

	}


	//--------------------------------------------
	// Resize
	//
			
	onResize(){
		this.windowHalfX = window.innerWidth / 2;
		this.windowHalfY = (window.innerHeight * CONSTANTS.HEIGHT_RATIO) / 2;

		this.w = window.innerWidth;
		this.h = window.innerHeight * CONSTANTS.HEIGHT_RATIO;


		this.cameraCube.aspect = this.w / this.h;
		this.cameraCube.updateProjectionMatrix();

		this.cameraWall.aspect = this.w / this.h;
		this.cameraWall.updateProjectionMatrix();

		this.renderer.setSize(this.w, this.h);

		this.container.style.height = window.innerHeight * CONSTANTS.HEIGHT_RATIO + 'px';
	}
			

	//--------------------------------------------
	//
	// Render Loop
	//
	//--------------------------------------------
			
	render(){
		const self = this;
		const timer = 0.0001 * Date.now();

		//--------------------------------------------
		// Skybox rotations
		//
				
		if (self.skyBox && this.autoRotate){
			self.skyBox.rotation.y = timer;

			this.lastRotateY = this.skyBox.rotation.y;
		}

		if (self.walls){
			self.walls.rotation.x = self.walls.rotation.y = timer;
		}


		if (self.oc){
			self.oc.rotation.y = timer;
		}

		



		//--------------------------------------------
		// Particles
		//
				
		for (let i = 0; i < this.sceneWall.children.length; i++ ){

			var object = self.sceneWall.children[i];

			if (object instanceof THREE.Points){
				object.material.opacity = object.material.opacity - 0.009;
				object.rotation.x = timer;

				if (object.material.opacity <= 0){
					self.sceneWall.remove(object);
				}
			}

			if (object instanceof THREE.Sprite){
				object.position.y += 0.01 * (i + 1);

				if (i % 2 === 0){
					object.position.x += 0.01 * (i + 1);
				}

				else{
					object.position.x -= 0.01 * (i + 1);
				}

				object.material.opacity = object.material.opacity - 0.000025;

				if (object.material.opacity <= 0){
					self.sceneWall.remove(object);
				}

			}
		}



		this.renderer.clear();
		this.renderer.render(this.sceneCube, this.cameraCube);
		this.renderer.clearDepth();
		this.renderer.render(this.sceneWall, this.cameraWall);
		
	}


	stop(){
		cancelAnimationFrame(this.animationLoop);
	}

	resume(){
		this.animate();
	}

	//--------------------------------------------
	// Animation Frame
	//		
	animate(){

		this.render();

		this.animationLoop = requestAnimationFrame(this.animate.bind(this));
	}

	//--------------------------------------------
	// Random interval used for notifications control
	//		
	randomInterval(min, max){
		return Math.floor(Math.random() * (max - min + 1) + min);
	}

}

export default Scene;